import {ContactsMenu} from "./conponents/ContactsMenu.tsx"
import {ContactsMap} from "@/pages/static/Contacts/conponents/ContactsMap.tsx";
import styles from "./ContactsPage.module.scss";
import {cn} from "@/utils/cn.ts";

/**
 * Страница контактов
 * @constructor
 */
export const ContactsPage: React.FC = () => {
    return (
        <div className={cn("contacts-container", styles.container)}>
            <ContactsMenu/>
            <ContactsMap/>
            <ContactsMenu size='xs'/>
        </div>
    );
};
